<template>
    <div class="bg-white" v-hotkey="keymap">
        <div class="container nikud-edit">
            <information-bar ref="info-bar"/>
            <b-row no-gutters v-if="showWrongGenreNotification">
                <b-col cols="9">
                    <div class="wrong-genre-notification">
                        <p class="wrong-genre-notification-text"><span @click="showWrongGenreNotification = false"><i-times
                                class="ml-1"></i-times></span>
                            זהינו שאתה משתמש בטקסט <span>{{ correctGenreText }}</span>.
                            למעבר לנקדן ה<span>{{ correctGenreText }}</span>
                            <span @click="switchGenre" class="click-to-switch-genre pr-2">לחץ כאן</span>
                            <i-info-circle class="pr-2" v-b-popover.hover.bottom="wrongGenreToolTipText"></i-info-circle>
                        </p>
                    </div>
                </b-col>
            </b-row>
            <b-row no-gutters class="nikud-edit-window">
                <b-col cols="9" class="full-height">
                    <div class="results-side">
                        <nikud-results-container class="results" :modes-obj="modesObj" ref="results-container"
                                                 :show-saved-state-message="showSavedStateMessage"
                                                 @back-to-text-prep-confirmed="backToTextPrepConfirmed = true"
                                                 @saving-and-completing="(statusObj) => savingAndCompletingStatusObj = statusObj"
                                                 :edit-nikud-props="editNikudProps"/>
                    </div>
                </b-col>
                <b-col class="full-height" cols="3">
                    <div class="controls-side">
                        <nikud-pane-container class="full-height" :modes-obj="modesObj"
                                              :edit-nikud-props="editNikudProps"/>
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-modal v-model="showSwitchGenrePrompt"
                id="switch-genre-modal"
                size="sm"
                centered
                hide-header
                ok-title="עבור"
                cancel-title="ביטול"
                footer-class="switch-genre-footer"
                @ok="actuallySwitchGenre">
            <p class="text-center mb-0">במעבר לנקדן אחר, תאבד את <br/>הניקוד הקיים</p>
            <span class="text-center"><b-form-checkbox v-model="disableSwitchGenrePromptOption">אל תציג שוב</b-form-checkbox></span>
        </b-modal>
        <failed-validation-popup />
    </div>
</template>

<script>
    // @ is an alias to /src
    import NikudPaneContainer from '@/components/NikudPaneContainer.vue'
    import NikudResultsContainer from '@/components/NikudResultsContainer.vue'
    import InformationBar from '@/components/InformationBar.vue'
    import nikudMixins from '@/mixins/nikudMixins'
    import serviceMixins from '@/mixins/serviceMixins'
    import navigationMixins from '@/mixins/navigationMixins'
    import resultsIntegrationMixins from '@/mixins/resultsIntegrationMixins'
    import {Actions} from '@/store/stateChanges'
    import {StateSaver, loadingPromise} from '@/js/localData'
    import {RunStates} from '@/store/runStates'
    import FailedValidationPopup from '@/components/FailedValidationPopup.vue'
    import wordMutatingMixins from '@/mixins/wordMutatingMixins'
    import {getLetterWithReversedDageshFromLetterArray} from 'shared/js/commonHebrew'
    import $ from 'jquery'
    import {AppConfig} from '../appConfig'

    const wrongGenreDescription = 'נקדן מודרני: מבוסס על כללי הניקוד המקובלים כיום על ידי האקדמיה ללשון.\nנקדן רבני: מתחשב בכללי ניקוד ייחודיים שאינם תואמים את הכללים הנורמטיבים של העברית המודרנית.\nנקדן שירה: נשען על הסתברות של ניקוד עבור טקסטים שיריים.'
    export default {
        name: 'NikudEdit',
        props: ['globalModesObj'],
        components: {
            NikudResultsContainer,
            NikudPaneContainer,
            FailedValidationPopup,
            InformationBar
        },
        data() {
            return {
                showSavedStateMessage: false,
                intervalHolder: null,
                backToTextPrepConfirmed: false,
                savingAndCompletingStatusObj: {},
                modesObj: {
                    letterAddingMode: false,
                    wordMutationCount: 0
                },
                genreHebrewNames: {
                    modern: 'מודרני',
                    rabbinic: 'רבני',
                    poetry: 'שירה',
                    talmud: 'תלמוד'
                },
                correctGenre: null,
                showWrongGenreNotification: false,
                wrongGenreToolTipText: wrongGenreDescription,
                disableSwitchGenrePromptOption: false,
                showSwitchGenrePrompt: false,
                editNikudProps: {
                    workingIndices: null,
                    showEditNikud: false
                },
                keymap: {
                    'shift+i': () => {
                        if (this.canChangeNikud && !(this.modalOpen())) this.clearNikudEffectiveImmediately(this.localCurrentWord, this.localCurrentWordIndex)
                    },
                    'ctrl+i': () => {
                        if (this.canChangeNikud && !(this.modalOpen())) this.clearNikudEffectiveImmediately(this.localCurrentWord, this.localCurrentWordIndex)
                    },
                    'shift+s': () => {
                        if (AppConfig.NON_CONFIDENT_MARKING && this.canChangeNikud && !(this.modalOpen())) {
                            this.toggleCurrentWordMarkedNonConfident()
                        }
                    },
                    'g': () => {
                        if (!(this.localLetterAddingMode) && !(this.modalOpen())
                            && !($('.manual-input').is(':focus'))) {
                            this.moveToNextWord()
                        }
                    },
                    'shift+/': () => { if (this.canChangeNikud && !(this.modalOpen())) this.toggleDageshInFirstLetterEffectiveImmediately() },
                    'ctrl+/': () => { if (this.canChangeNikud && !(this.modalOpen())) this.toggleDageshInFirstLetterEffectiveImmediately() },
                    'h': () => {
                        if (!(this.localLetterAddingMode) && !(this.modalOpen())
                            && !($('.manual-input').is(':focus'))) {
                            this.moveToPreviousWord()
                        }
                    },
                    'shift+T': () => {
                        if (!(this.modalOpen()) && !($('.manual-input').is(':focus'))) {
                            this.$store.commit('SET_SHOW_AIMS', !(this.$store.state.postSubmissionOptions.showAims))
                        }
                    }
                    // 'ctrl+T': () => {
                    //     if (!(this.modalOpen())) {
                    //         this.$store.commit('SET_SHOW_AIMS', !(this.$store.state.postSubmissionOptions.showAims))
                    //     }
                    // },
                }
            }
        },
        computed: {
            canChangeNikud () {
                return !(this.localLetterAddingMode) && this.currentLetterNotSep
            },
            localEditNikudMode() {
                return this.editNikudProps.showEditNikud
            },
            genreClassificationComplete() {
                return this.$store.state.genreClassifyApiState === RunStates.COMPLETE
            },
            correctGenreText() {
                return this.correctGenre ? this.genreHebrewNames[this.correctGenre] : '[לא נבחר סגנון]'
            }
        },
        watch: {
            localLetterAddingMode(newLocalLetterAddingMode) {
                if (newLocalLetterAddingMode) {
                    document.title = 'פיענוח ראשי תיבות רבניים - חינמי מבית דיקטה (הוספה)'
                } else if (this.editNikudProps.showEditNikud) {
                    document.title = 'פיענוח ראשי תיבות רבניים - חינמי מבית דיקטה (עריכה)'
                } else document.title = 'פיענוח ראשי תיבות רבניים - חינמי מבית דיקטה'
            },
            localEditNikudMode(newLocalEditNikudMode) {
                if (newLocalEditNikudMode) {
                    document.title = 'פיענוח ראשי תיבות רבניים - חינמי מבית דיקטה (עריכה)'
                } else if (this.localLetterAddingMode) {
                    document.title = 'פיענוח ראשי תיבות רבניים - חינמי מבית דיקטה (הוספה)'
                } else document.title = 'פיענוח ראשי תיבות רבניים - חינמי מבית דיקטה'
            },
            genreClassificationComplete(newGenreClassificationComplete) {
                if (newGenreClassificationComplete) this.useGenreClassification()
            }
        },
        mixins: [
            nikudMixins, /* for the direct use of: localLetterAddingMode, localCurrentWordIndex,
                                localCurrentLetterIndex, localCurrentWord, currentLetterNotSep,
                                and modalOpen() */
            resultsIntegrationMixins, // for populateAllWorkingNikud() and clearNikudEffectiveImmediately()
            wordMutatingMixins, /* for the direct use of: rewriteWordOrWordsInWorkingArrayMethod() ...
                                ...& b/c (now) whoever uses resultsIntegrationMixins needs wordMutatingMixins too */
            navigationMixins, // for moveToNextWord(), moveToPreviousWord(), & moveToWordMethod()
            serviceMixins // for googleAnalyticsId and gtag()
        ],
        methods: {
            toggleDageshInFirstLetterEffectiveImmediately () {
                var letterArray = this.localCurrentWord.standardLetterArray
                var currentLetter = 0
                letterArray[currentLetter] = getLetterWithReversedDageshFromLetterArray(letterArray, currentLetter)
                this.rewriteWordOrWordsInWorkingArrayMethod({
                    contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
                    newWordContainer: {
                        index: this.localCurrentWordIndex, changes: {
                            altered: true,
                            choiceType: 'manual',
                            manualNikud: letterArray.join('')
                        }
                    }
                })
            },
            toggleCurrentWordMarkedNonConfident () {
                this.rewriteWordOrWordsInWorkingArrayMethod({
                    contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
                    newWordContainer: {
                        index: this.localCurrentWordIndex, changes: {
                            specialData: Object.assign({}, this.localCurrentWord.specialData,
                                { markedNonConfident: !(this.localCurrentWord.specialData.markedNonConfident) })
                        }
                    }
                })
            },
            useGenreClassification() {
                if (!(AppConfig.USE_GENRE_CLASSIFICATION)) return
                if (this.$store.state.originalDocument.identifiedGenre !== this.$store.state.preSubmissionOptions.chosenTextTypeName) {
                    this.correctGenre = this.$store.state.originalDocument.identifiedGenre
                    this.showWrongGenreNotification = true
                }
            },
            switchGenre() {
                if (!(this.$store.state.postSubmissionOptions.disableSwitchGenrePrompt)) { 
                    this.showSwitchGenrePrompt = true 
                } else this.actuallySwitchGenre()
            },
            actuallySwitchGenre() {
                this.showSwitchGenrePrompt = false
                if (this.disableSwitchGenrePromptOption) this.$store.commit('SET_DISABLE_SWITCH_GENRE_PROMPT', true)
                this.$store.commit('STORE_ALL_PRE_SUBMISSION_OPTIONS',
                    Object.assign(this.$store.state.preSubmissionOptions, {chosenTextTypeName: this.correctGenre}))
                this.$store.dispatch(Actions.RUN_NAKDAN)
                this.$router.push({name: 'text-prep'})
            },
            beforeUnloadHandler (event) {
                // var unsaved = true // no "being unsaved" is needed
                StateSaver.saveState()
                if (!(this.$store.state.account && this.$store.state.account.loginInProgress)
                    && !(this.globalModesObj.allowLeaving) && process.env.NODE_ENV !== "development") { // (unsaved) {
                    event.preventDefault()
                    event.returnValue = 'preventing unload'
                    return 'preventing unload'
                }
            }
        },
        mounted: function () {
            this.disableSwitchGenrePromptOption = this.$store.state.postSubmissionOptions.disableSwitchGenrePrompt
            this.gtag('config', this.googleAnalyticsId, {"page_path": "edit"})
            this.$store.commit('SET_CURRENT_WORD_INDEX', -1)
            loadingPromise.then(() =>{
                let whetherToMove = true
                if (!(this.$store.state.allWorkingNikud.wordsArray.length)) {
                    if (this.$store.state.nakdanApiResponse.length) {
                        if (this.$store.state.allWorkingNikud.id !== this.$store.state.originalDocument.id) {
                            whetherToMove = this.populateAllWorkingNikud()
                        }
                    } else this.$router.push({ name: 'text-prep' } )
                }
                if (whetherToMove) {
                    const wordIndexBeforeMove = this.localCurrentWordIndex
                    setTimeout(() => {
                        if (wordIndexBeforeMove === -1) {
                            var newWordIndex = 0
                            while (newWordIndex < this.$store.state.allWorkingNikud.wordsArray.length
                                    && !(this.$store.state.allWorkingNikud.wordsArray[newWordIndex].wasAnAbbreviation)) {
                                newWordIndex++
                            }
                            newWordIndex = newWordIndex < this.$store.state.allWorkingNikud.wordsArray.length
                                            ? newWordIndex : 0
                            if (newWordIndex !== this.localCurrentWordIndex) {
                                const wordObj = this.$store.state.allWorkingNikud.wordsArray[newWordIndex]
                                const firstLetterIndex = wordObj.sepBefore.length
                                this.$store.commit('SET_WORD_AND_LETTER', {
                                    word: newWordIndex,
                                    letter: firstLetterIndex
                                })
                            }
                        } else this.$store.commit('SET_CURRENT_WORD_INDEX', wordIndexBeforeMove)
                    }, 10) // wait for results-container to finish mounting
                }
            })
            if (this.genreClassificationComplete) this.useGenreClassification()
            this.intervalHolder = setInterval(() => {
                StateSaver.saveState(this.$store.state)
                // eslint-disable-next-line no-console
                console.log('Saved state! Time: ' + new Date().toTimeString().split(' ')[0])
                this.showSavedStateMessage = true
                setTimeout(() => { this.showSavedStateMessage = false }, 4000)
            }, 300000)
            window.addEventListener('beforeunload', this.beforeUnloadHandler)
        },
        beforeDestroy() {
            clearInterval(this.intervalHolder)
            StateSaver.saveState(this.$store.state)
        },
        beforeRouteLeave (to, from, next) {
            if (!(this.backToTextPrepConfirmed || this.globalModesObj.allowLeaving) 
                && !(this.$store.state.account && this.$store.state.account.loginInProgress)
                && !(this.savingAndCompletingStatusObj.successSoGoingToProjects)
                && process.env.NODE_ENV !== "development") {
                const answer = window.confirm('נא לאשר שאתם באמת רוצים לצאת') // actually the browser will use its own words
                if (!answer) {
                    next(false)
                    return
                }
            }
            window.removeEventListener('beforeunload', this.beforeUnloadHandler)
            this.globalModesObj.allowLeaving = false
            next()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Nikud-Edit-specific CSS goes here */
    .nikud-edit {
        height: 100%;
        flex-direction: column;
        display: flex;
    }
    .nikud-edit-window {
        height: 100%;
        position: relative;
        /*border: solid 1px #d8d8d8;*/
        border-radius: 4px;
    }

    .results-side, .controls-side {
        position: relative;
    }

    .controls-side {
        height: 100%;
        margin-left: 8px;
        padding: 4px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .he .controls-side {
        margin-right: 8px;
        margin-left: 0;
    }
    .results-side {
        /* in the control side, the shadow is inside, but on the result side the shadow is outside */
        margin-top: 4px;
        height: calc(100% - 8px);
        background-color: #f6f6f6;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.15);
        border: solid 1px #e3e3e3;
        border-radius: 4px;
    }

    .wrong-genre-notification, .opposite-wrong-genre-notification {
        height: 20px;
        flex: none;
    }

    .wrong-genre-notification {
        text-align: right;
    }

    .wrong-genre-notification {
        background-color: #f6f6f6;
        position: relative;
        height: 28px;
        border-radius: 2px;
        margin-bottom: 15px;
        padding: 4px 10px;
    }

    .wrong-genre-notification-text {

        font-size: 13px;
        margin-bottom: 0;
    }

    .click-to-switch-genre {
        color: #007ee5;
        cursor: pointer;
    }

    @media (min-width: 1140px) {

    }
</style>
